export default __webpack_public_path__ + "static/media/illustration-recruit-4-m@2x.3ac037cc.webp";